import { Alert, AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, AlertIcon, Avatar, AvatarBadge, Badge, Box, Button, Card, CardBody, Checkbox, Divider, Flex, FormControl, FormLabel, Grid, Heading, Icon, IconButton, Input, InputGroup, InputLeftElement, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverTrigger, Select, Stack, Table, TableContainer, Tbody, Td, Text, Textarea, Th, Thead, Tr, useColorModeValue, useDisclosure, useToast, VStack } from '@chakra-ui/react'
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useStateContext } from '../../context/ContextProvider';
import axiosClient from '../../axios-client';
import { ChevronDownIcon, CloseIcon, DeleteIcon, EditIcon, SearchIcon } from '@chakra-ui/icons';
import MyPagination from "../../components/MyPagination";
import { PiPlusBold } from 'react-icons/pi';
import animationData from '../../assets/lotties/subscribe.json'
import Lottie from 'react-lottie';
import { useTranslation } from 'react-i18next';
import makeAnimated from 'react-select/animated';
import MySelect from 'react-select';
import { FaExclamationTriangle, FaEye, FaKey, FaPencilAlt } from 'react-icons/fa';
import Resizer from "react-image-file-resizer";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { HiDotsVertical } from "react-icons/hi";

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};


function GestSubscription() {
    const navigate = useNavigate()
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [id, setId] = useState(null);
    const toast = useToast()
    const cancelRef = React.useRef()
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [message, setMessage] = useState('');
    const [subData, setSubData] = useState();
    const [price, setPrice] = useState();
    const [name, setName] = useState('');
    const [simultaneousScreens, setSimultaneousScreens] = useState();
    const [subId, setSubId] = useState('');
    const [description, setDescription] = useState('');
    const [subscription, setSubscription] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    const [freeTrialDays, setFreeTrialDays] = useState('');

    const [selectedType, setSelectedType] = useState(null);
    const [type, setType] = useState(null);

    const [isChangeStripeIdOpen, setIsChangeStripeIdOpen] = useState(false);
    const [selectedSub, setSelectedSub] = useState();
    const [stripeProductId, setStripeProductId] = useState('');
    const [stripePriceId, setStripePriceId] = useState('');

    const onOpenStripeIdModal = () => {
        setIsChangeStripeIdOpen(true);
    };
    const onCloseStripeIdModal = () => {
        setIsChangeStripeIdOpen(false);
        setStripeProductId('')
        setStripePriceId('')
    };
    //search variable
    const [searchTerm, setSearchTerm] = useState('');

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [changeModal, setChangeModal] = useState(true)

    const onOpenAlert = () => {
        setIsAlertOpen(true);
    };
    const onCloseAlert = () => {
        setIsAlertOpen(false);
    };
    const onOpenPreview = () => {
        setIsPreviewOpen(true);
    };
    const onClosePreview = () => {
        setIsPreviewOpen(false);
    };

    const handleTypeChange = (ev) => {
        const type = ev.target.value;
        setSelectedType(type)
        if (type !== 'TRIAL') {
            setFreeTrialDays('');
        }
    }
    const [features, setFeatures] = useState([]);

    const handleFeatureChange = (e, index) => {
        const newFeatures = [...features];
        newFeatures[index] = e.target.value;
        setFeatures(newFeatures);
    };

    const addFeature = () => {
        setFeatures([...features, ""]);
    };

    const removeFeature = (index) => {
        const newFeatures = features.filter((_, i) => i !== index);
        setFeatures(newFeatures);
    };
    ////////////////////////////////the size of the table//////////////////////////////
    const PAGE_SIZE = 5;
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
        setCurrentPage(0);
    };
    //////////////////////////////////////////////////////////////////////////////////
    const [checkLengthData, setCheckLengthData] = useState(false)
    const [loadingData, setLoadingData] = useState(true)
    const [paginationData, setPaginationData] = useState()

    useEffect(() => {
        axiosClient.get(`/subscriptions/`)
            .then((response) => {
                let filteredData = response.data;
                setPaginationData(response.data);

                if (filteredData.length === 0) {
                    setCheckLengthData(true)
                }
                else {
                    setData(filteredData);
                }
                setLoadingData(false)
            })
            .catch((error) => {
                // console.error(error);
                setLoadingData(false)

            });

    }, [searchTerm])

    function update() {
        axiosClient.get(`/subscriptions/`)
            .then((response) => {
                let filteredData = response.data;
                setPaginationData(response.data);

                if (filteredData.length === 0) {
                    setCheckLengthData(true)
                }
                else {
                    setData(filteredData);
                }
                setLoadingData(false)
            })
            .catch((error) => {
                // console.error(error);
                setLoadingData(false)

            });

    }

    const handleDelete = (id) => {
        if (!id) return;
        axiosClient.delete(`/subscriptions/delete/${id}/`)
            .then((response) => {
                setData((prevData) => prevData.filter((row) => row.id !== id));
                toast({
                    description: t("L'abonnements est supprimé avec succès"),
                    status: 'success',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                })
            })
            .catch((error) => {
                console.error(error);
            });
        onCloseAlert()
    }

    const AjoutSubscription = async () => {

        if (
            !name ||
            !description ||
            (!price && selectedType !== 'TRIAL') ||
            !selectedType ||
            features.length === 0 ||
            features.some(f => !f.trim()) ||
            (selectedType === 'TRIAL' && !freeTrialDays)
        ) {
            setMessage(t("Veuillez remplir tous les champs obligatoires"));
            return;
        }
        setIsLoading(true)
        try {

            const formData = new FormData();
            formData.append("name", name);
            formData.append("description", description);
            if (selectedType !== 'TRIAL') {
                formData.append("price", price);
            } else {
                formData.append("free_trial_days", freeTrialDays);
                formData.append("price", 0);
            }
            formData.append("type", selectedType);
            formData.append("simultaneousScreens", simultaneousScreens);

            // Append features as a JSON string
            formData.append("features", JSON.stringify(features));

            axiosClient.post('/subscriptions/create/', formData)
                .then((response) => {
                    toast({
                        description: 'Abonnement ajouté avec succès.',
                        status: 'success',
                        duration: 3000,
                        isClosable: true,
                        position: "bottom-right",
                        variant: "left-accent"
                    });
                    // navigate('/series')
                    update()
                    onClose()
                    setName('')
                    setDescription('')
                    setFeatures([]);
                    setPrice()
                    setFreeTrialDays('');
                    setSelectedType('');
                    setSimultaneousScreens()
                    setIsLoading(false)
                })
                .catch((err) => {
                    const response = err.response;
                    setMessage(t("Une erreur s'est produite lors de l'ajout d'abonnement"));
                    // console.error(response);
                    setIsLoading(false)

                })


        } catch (error) {
            // console.error(error);
            setMessage(t("Une erreur s'est produite lors de l'ajout d'abonnement"));
            setIsLoading(false)
        }
    }

    const UpdateSubscription = async (id) => {
        setIsLoading(true)
        try {

            const formData = new FormData();
            if (name) formData.append("name", name);
            if (description) formData.append("description", description);
            if (price) formData.append("price", price);
            if (simultaneousScreens) formData.append("simultaneousScreens", simultaneousScreens);
            // if(selectedType) formData.append("type", selectedType);

            // Append features as a JSON string
            formData.append("features", JSON.stringify(features));
            axiosClient.put(`/subscriptions/update/${id}/`, formData)
                .then((response) => {
                    toast({
                        description: 'Abonnement modifié avec succès.',
                        status: 'success',
                        duration: 3000,
                        isClosable: true,
                        position: "bottom-right",
                        variant: "left-accent"
                    });
                    // navigate('/series')
                    update()
                    onClose()
                    setName('')
                    setDescription('')
                    setSimultaneousScreens()
                    setFeatures([]);
                    setPrice()
                    setIsLoading(false)
                })
                .catch((err) => {
                    const response = err.response;
                    setIsLoading(false)
                    // console.error(response);

                })

        } catch (error) {
            // console.error(error);
            setMessage(t("Une erreur s'est produite lors de la mise à jour du type"));
            setIsLoading(false)
        }
    };
    const handleChangeEtat = async (id, isChecked) => {
        try {
            const formData = new FormData();
            formData.append("etat", isChecked);
            const response = await axiosClient.put(`/subscriptions/update/${id}/`, formData);

            toast({
                description: `L'etat d'abonnement est modifié avec succès`,
                status: 'success',
                duration: 3000,
                isClosable: true,
                position: 'bottom-right',
                variant: "left-accent"
            });

            update();
        } catch (err) {
            const errorMessage = err?.response?.data?.error || "Erreur lors de la mise à jour.";
            throw new Error(errorMessage);
        }
    };

    const bgCard = useColorModeValue("white", "gray.800")
    const bgEssCard = useColorModeValue("purple.50", "gray.700")
    const cardBorder = useColorModeValue("gray.200", "gray.600")
    const textColor = useColorModeValue("gray.600", "gray.400")

    // const handleStripeIdsChange = (id) => {
    //     const formData = new FormData();
    //     formData.append("stripe_product_id", stripeProductId);
    //     formData.append("stripe_price_id", stripePriceId);

    //     axiosClient.put(`/update_subscription_ids/${id}/`, formData)
    //         .then((response) => {
    //             toast({
    //                 description: t("Les informations d'identification Stripe ont été mises à jour avec succès"),
    //                 status: 'success',
    //                 variant: 'left-accent',
    //                 duration: 2000,
    //                 isClosable: true,
    //                 position: 'bottom-right'
    //             })
    //             setStripePriceId("")
    //             setStripeProductId("")
    //             onCloseStripeIdModal()
    //             update()
    //         })
    //         .catch((error) => {
    //             // console.error(error)
    //         });

    // }

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;

        // Reorder the items
        const reorderedItems = Array.from(data);
        const [movedItem] = reorderedItems.splice(result.source.index, 1);
        reorderedItems.splice(result.destination.index, 0, movedItem);

        setData(reorderedItems);

        // Update the database with the new order
        updateDatabase(reorderedItems);
    };
    const updateDatabase = (newOrder) => {
        const updatedOrder = newOrder.map((item, index) => ({
            id: item.id,
            order: index,
        }));

        axiosClient.post('/subscriptions/update_order/', updatedOrder)
            .then(response => {
                // console.log("Order updated successfully:", response.data);
            })
            .catch(error => {
                // console.error("Error updating order:", error);
            });
    };

    return (
        <Box>

            <Flex>
                <Box w="100%" display={"flex"} justifyContent="space-between" flexDirection={{ base: 'column', md: "row" }} mt={2} mb={{ base: 0, md: 5 }}>
                    <Text fontFamily='Plus Jakarta Display' as="cite" fontSize={{ base: "18px", md: "20px", lg: "25px" }} color="gray"><span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t("Accueil")}</span>  / <span>{t("Abonnements")}</span> </Text>
                    <Button color={"white"} bgGradient='linear(to-r, #eb6921, #fa8d51)' _hover={{ bgGradient: 'linear(to-r, #eb6921,#eb6921)' }} mb={{ base: 5, md: 0 }} onClick={() => {
                        onOpen()
                        setChangeModal(true)
                    }}
                        leftIcon={<PiPlusBold />} variant='solid'
                    // isDisabled={data.some(sub => sub.type === "ANNUEL") && data.some(sub => sub.type === "MENSUEL")}
                    >
                        {t("Ajouter abonnement")}
                    </Button>
                </Box>

            </Flex>
            <Flex direction='column' mt={{ sm: '25px', md: '0px' }} p={{ base: 0, lg: 7 }}>

                <Grid templateColumns={{ sm: "1fr", md: "1fr", lg: "2fr 1fr " }} justify={"center"} gap='22px'>
                    <DragDropContext onDragEnd={handleOnDragEnd}>
                        <Droppable droppableId="droppable">
                            {(provided) => (
                                <Box ref={provided.innerRef} {...provided.droppableProps} mt={5} display="flex" flexDirection="column" gap={5}>
                                    {data.length ? (
                                        data.map((row, index) => (
                                            <Draggable key={row.id} draggableId={row.id.toString()} index={index}>
                                                {(provided) => (
                                                    <Box
                                                        ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
                                                        key={index}
                                                        p={5}
                                                        bg={row.type === "TRIAL" ? bgEssCard : bgCard}
                                                        shadow="lg"
                                                        rounded="lg"
                                                        borderWidth="1px"
                                                        borderColor={cardBorder}
                                                        opacity={row.etat ? 1 : 0.6}
                                                        filter={row.etat ? "none" : "grayscale(0.6)"}
                                                        overflow="hidden"
                                                    >
                                                        <Flex justify={"space-between"}>
                                                            <Flex justify={"center"} gap={2} mb={3}>
                                                                <Heading color={"orange.400"} size="md" >
                                                                    {row.name}
                                                                </Heading>
                                                                {row.is_main_subscription &&
                                                                    <Badge alignItems={"center"} display={'flex'} px={1} mx={2} rounded={"xl"} colorScheme='cyan'> Abonnement principal </Badge>

                                                                }
                                                            </Flex>


                                                            <Flex gap={3} >
                                                                {/* <IconButton
                                                size="sm"
                                                onClick={() => {
                                                    setDeleteId(row.id);
                                                    onOpenAlert();
                                                }}
                                                variant="outline"
                                                colorScheme="green"
                                                icon={<FaKey />}
                                            />
                                            <IconButton
                                                size="sm"
                                                onClick={() => {
                                                    setDeleteId(row.id);
                                                    onOpenAlert();
                                                }}
                                                variant="outline"
                                                colorScheme="red"
                                                icon={<DeleteIcon />}
                                                aria-label={`Delete ${row.name}`}
                                            />
                                            <IconButton
                                                size="sm"
                                                onClick={() => {
                                                    setSubData(row);
                                                    setChangeModal(false);
                                                    setFeatures(row.features);
                                                    onOpen();
                                                    setSubId(row.id);
                                                }}
                                                variant="outline"
                                                colorScheme="yellow"
                                                icon={<EditIcon />}
                                            /> */}
                                                                <IconButton
                                                                    size="sm"
                                                                    onClick={() => {
                                                                        onOpenPreview();
                                                                        setSubscription(row);
                                                                    }}
                                                                    variant="solid"
                                                                    colorScheme="blue"
                                                                    icon={<FaEye />}
                                                                />
                                                                <Menu>
                                                                    <MenuButton as={IconButton} size="sm" variant="outline" colorScheme="green" icon={<HiDotsVertical />} />
                                                                    <MenuList>

                                                                        <MenuItem closeOnSelect={false}>
                                                                            <Checkbox
                                                                                isChecked={row.etat}
                                                                                onChange={async (e) => {
                                                                                    const isChecked = e.target.checked;

                                                                                    try {
                                                                                        await handleChangeEtat(row.id, isChecked);
                                                                                    } catch (error) {
                                                                                        toast({
                                                                                            description: error?.message || "Une erreur est survenue",
                                                                                            status: "error",
                                                                                            duration: 3000,
                                                                                            isClosable: true,
                                                                                            position: "bottom-right",
                                                                                            variant: "left-accent"
                                                                                        });
                                                                                    }
                                                                                }}
                                                                            >
                                                                                Activer l'abonnement
                                                                            </Checkbox>
                                                                        </MenuItem>

                                                                        {/* <MenuItem
                                                                            onClick={() => {
                                                                                setSubId(row.id);
                                                                                setSelectedSub(row)
                                                                                onOpenStripeIdModal();
                                                                            }}
                                                                            icon={<FaKey color='gray' />}
                                                                        >
                                                                            Modifier les clés
                                                                        </MenuItem> */}
                                                                        {/* <MenuItem
                                                                            onClick={() => {
                                                                                setDeleteId(row.id);
                                                                                setType(row.type)
                                                                                onOpenAlert();
                                                                            }}
                                                                            icon={<DeleteIcon color={"red"} />}
                                                                            aria-label={`Delete ${row.name}`}
                                                                        >
                                                                            Supprimer
                                                                        </MenuItem> */}
                                                                        <MenuItem
                                                                            onClick={() => {
                                                                                setSubData(row);
                                                                                setChangeModal(false);
                                                                                setFeatures(row.features);
                                                                                onOpen();
                                                                                setSubId(row.id);
                                                                                setSelectedType(row.type)
                                                                            }}
                                                                            icon={<EditIcon color={"green"} />}
                                                                        >
                                                                            Modifier
                                                                        </MenuItem>
                                                                    </MenuList>
                                                                </Menu>

                                                            </Flex>
                                                        </Flex>

                                                        <Text color={textColor} mb={2}>
                                                            <Text as="span" fontWeight="bold">{t("Description")}: </Text>
                                                            {row.description}
                                                        </Text>
                                                        {row.type === "TRIAL" ?
                                                            <Text color={textColor} mb={2}>
                                                                <Text as="span" fontWeight="bold">{t("Nombre de jours ")}: </Text>
                                                                {row.free_trial_days || "--------"}
                                                            </Text>
                                                            :
                                                            <Text color={textColor} mb={2}>
                                                                <Text as="span" fontWeight="bold">{t("Prix")}: </Text>
                                                                {row.price + " €" || "--------"}
                                                            </Text>
                                                        }

                                                        <Text color={textColor} mb={2}>
                                                            <Text as="span" fontWeight="bold">{t("Type")}: </Text>
                                                            {(row.type === "TRIAL" ? "Essai gratuit" : row.type.toLowerCase()) || "--------"}
                                                        </Text>
                                                        <Text color={textColor} mb={2}>
                                                            <Text as="span" fontWeight="bold">{t("Date Création")}: </Text>
                                                            {new Date(row.creation_date).toLocaleDateString('fr-FR')}
                                                        </Text>

                                                    </Box>
                                                )}
                                            </Draggable>
                                        ))
                                    ) : (
                                        <Box>
                                            <Text>{t("Aucune ligne correspondante n'a été trouvée.")}</Text>
                                        </Box>
                                    )}
                                </Box>
                            )}
                        </Droppable>
                    </DragDropContext>
                    <Flex display={{ base: "none", lg: "flex" }} align={'center'}>
                        <Lottie style={{ height: "300px", width: "300px", objectFit: 'contain' }} options={defaultOptions} />
                    </Flex>
                </Grid>
            </Flex>
            <AlertDialog
                isOpen={isAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t("Supprimer")}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {t("êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.")}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseAlert}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={() => handleDelete(id)} colorScheme='red' ml={3}>
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
            {changeModal ?
                <Modal size={"xl"} isOpen={isOpen} onClose={() => {
                    onClose();
                    setMessage('');
                    setFeatures([]);
                }}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>{t("Ajout d'abonnement")}</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody pb={6}>
                            {message &&
                                <Alert mb={2} fontSize={"sm"} padding={2} variant={"left-accent"} status='error' rounded="md">
                                    <AlertIcon />
                                    {message}
                                </Alert>
                            }
                            <Flex flexDirection={'column'} align={'center'}>
                                <Flex w="100%" flexDirection={'column'}>
                                    <FormControl isRequired mb={3}>
                                        <FormLabel>{t("Nom d'abonnement")}</FormLabel>
                                        <Input maxLength={50} name="name" onChange={e => setName(e.target.value)} placeholder={t("Nom d'abonnement")} />
                                    </FormControl>

                                    <FormControl isRequired mb={3}>
                                        <FormLabel>Description</FormLabel>
                                        <Textarea
                                            maxLength={255}
                                            resize={'none'}
                                            placeholder="Description"
                                            onChange={e => setDescription(e.target.value)}
                                        />
                                    </FormControl>

                                    <FormControl isRequired mb={3}>
                                        <FormLabel>{t("Type")}</FormLabel>
                                        <Select onChange={handleTypeChange} placeholder={t("Sélectionnez le type d'abonnement")}>

                                            {/* {!data.some(sub => sub.type === "ANNUEL") && ( */}
                                            <option value='ANNUEL'>{t("Annuel")}</option>
                                            {/* )} */}
                                            {/* {!data.some(sub => sub.type === "MENSUEL") && ( */}
                                            <option value='MENSUEL'>{t("Mensuel")}</option>
                                            {/* )} */}
                                            {!data.some(sub => sub.type === "TRIAL") && (
                                                <option value='TRIAL'>{t("Essai gratuit")}</option>
                                            )}
                                        </Select>
                                    </FormControl>
                                    {selectedType === 'TRIAL' ? (
                                        <FormControl isRequired mb={3}>
                                            <FormLabel>{t("Nombre de jours d'essai gratuit")}</FormLabel>
                                            <Input
                                                type="number"
                                                min={1}
                                                value={freeTrialDays}
                                                onChange={e => setFreeTrialDays(e.target.value)}
                                                placeholder={t("Nombre de jours")}
                                            />
                                        </FormControl>
                                    ) :
                                        <FormControl isRequired mb={3}>
                                            <FormLabel>{t("Prix")}</FormLabel>
                                            <Input maxLength={50} name="price" onChange={e => setPrice(e.target.value)} placeholder={t("Prix d'abonnement")} />
                                        </FormControl>}

                                    <FormControl isRequired mb={3}>
                                        <FormLabel>{t("Ecrans simultanés")}</FormLabel>
                                        <Input maxLength={50} min={0} type='number' name="screens" onChange={e => setSimultaneousScreens(e.target.value)} placeholder={t("Nombre d'crans simultanés")} />
                                    </FormControl>
                                    {/* Features Field */}
                                    <FormControl mb={3}>
                                        <FormLabel>{t("Fonctionnalités")}</FormLabel>
                                        <VStack spacing={2} align="stretch">
                                            {features.map((feature, index) => (
                                                <Flex key={index} align="center">
                                                    <Input
                                                        value={feature}
                                                        onChange={e => {
                                                            const updatedFeatures = [...features];
                                                            updatedFeatures[index] = e.target.value;
                                                            setFeatures(updatedFeatures);
                                                        }}
                                                        placeholder={t("Ajouter une fonctionnalité")}
                                                    />
                                                    <CloseIcon
                                                        ml={5}
                                                        cursor={"pointer"}
                                                        aria-label="Delete filter section"
                                                        // icon={<CloseIcon />}
                                                        color="red"
                                                        variant="outline"
                                                        onClick={() => {
                                                            const updatedFeatures = features.filter((_, i) => i !== index);
                                                            setFeatures(updatedFeatures);
                                                        }}
                                                    />

                                                </Flex>
                                            ))}
                                            <Button
                                                mt={2}
                                                colorScheme="blue"
                                                onClick={() => setFeatures([...features, ""])}
                                            >
                                                {t("Ajouter une fonctionnalité")}
                                            </Button>
                                        </VStack>
                                    </FormControl>
                                </Flex>
                            </Flex>
                        </ModalBody>
                        <ModalFooter>
                            {
                                (!description || !name || !selectedType || !simultaneousScreens ||
                                    features.length === 0 ||
                                    features.some(f => !f.trim()) ||
                                    (selectedType === 'TRIAL' && !freeTrialDays) ||
                                    (selectedType !== 'TRIAL' && !price)
                                )
                                    ? <Button colorScheme='blue' isDisabled>{t("Ajouter")}</Button>
                                    : <Button
                                        isLoading={isLoading}
                                        isDisabled={isLoading}
                                        colorScheme='blue'
                                        onClick={AjoutSubscription}
                                    >
                                        {t("Ajouter")}
                                    </Button>
                            }

                        </ModalFooter>
                    </ModalContent>
                </Modal>

                :
                <Modal size={"xl"} isOpen={isOpen} onClose={() => {
                    onClose();
                    setMessage('');
                    setFeatures([]);

                }}>
                    <ModalOverlay />

                    <ModalContent>
                        <ModalHeader>{t("Modification d'abonnement")}</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody pb={6}>
                            {message && (
                                <Alert mb={2} fontSize={"sm"} padding={2} variant={"left-accent"} status='error' rounded="md">
                                    <AlertIcon />
                                    {message}
                                </Alert>
                            )}
                            <Flex flexDirection={'column'} align={'center'}>
                                <Flex w="100%" flexDirection={'column'}>
                                    <FormControl isRequired mb={3}>
                                        <FormLabel>{t("Nom d'abonnement")}</FormLabel>
                                        <Input
                                            defaultValue={subData.name}
                                            maxLength={50}
                                            name="name"
                                            onChange={e => setName(e.target.value)}
                                            placeholder={t("Nom d'abonnement")}
                                        />
                                    </FormControl>
                                    <FormControl isRequired mb={3}>
                                        <FormLabel>Description {selectedType}</FormLabel>
                                        <Textarea
                                            maxLength={255}
                                            resize={'none'}
                                            placeholder="Description"
                                            defaultValue={subData.description}
                                            onChange={e => setDescription(e.target.value)}
                                        />
                                    </FormControl>

                                    {/* {(!data.some(sub => sub.type === "ANNUEL") || !data.some(sub => sub.type === "MENSUEL") || !data.some(sub => sub.type === "TRIAL")) &&
                                        <FormControl isRequired mb={3}>
                                            <FormLabel>{t("Type")}</FormLabel>
                                            <Select
                                                defaultValue={selectedType}
                                                onChange={handleTypeChange}
                                                placeholder={t("Sélectionnez le type d'abonnement")}
                                            >
                                                {!data.some(sub => sub.type === "ANNUEL") && (
                                                    <option value='ANNUEL'>{t("Annuel")}</option>
                                                )}
                                                {!data.some(sub => sub.type === "MENSUEL") && (
                                                    <option value='MENSUEL'>{t("Mensuel")}</option>
                                                )}
                                                {!data.some(sub => sub.type === "TRIAL") && (
                                                    <option value='TRIAL'>{t("Essai gratuit")}</option>
                                                )}
                                            </Select>
                                        </FormControl>
                                    } */}
                                    {selectedType !== 'TRIAL' && (
                                        <FormControl isRequired mb={3}>
                                            <FormLabel>{t("Prix")}</FormLabel>
                                            <Input
                                                defaultValue={subData.price}
                                                maxLength={50}
                                                name="price"
                                                onChange={e => setPrice(e.target.value)}
                                                placeholder={t("Prix d'abonnement")}
                                            />
                                        </FormControl>
                                    )}
                                    {selectedType === 'TRIAL' && (
                                        <FormControl isRequired mb={3}>
                                            <FormLabel>{t("Nombre de jours d'essai")}</FormLabel>
                                            <Input
                                                type="number"
                                                min="1"
                                                defaultValue={subData.free_trial_days}
                                                onChange={(e) => setFreeTrialDays(e.target.value)}
                                                placeholder={t("Nombre de jours")}
                                            />
                                        </FormControl>
                                    )}

                                    <FormControl isRequired mb={3}>
                                        <FormLabel>{t("Ecrans simultanés")}</FormLabel>
                                        <Input
                                            defaultValue={subData.simultaneousScreens}
                                            min={0}
                                            type='number'
                                            name="screens"
                                            onChange={e => setSimultaneousScreens(e.target.value)}
                                            placeholder={t("Ecrans simultanés")}
                                        />
                                    </FormControl>
                                    {/* Features Section */}
                                    <FormControl mb={3}>
                                        <FormLabel>{t("Caractéristiques")}</FormLabel>
                                        <VStack spacing={2} align="stretch">

                                            {features.map((feature, index) => (
                                                <Flex key={index} mb={2} align="center">
                                                    <Input
                                                        value={feature}
                                                        onChange={(e) => handleFeatureChange(e, index)}
                                                        placeholder={t("Caractéristique")}
                                                    />
                                                    <CloseIcon
                                                        ml={5}
                                                        cursor={"pointer"}
                                                        aria-label="Delete filter section"
                                                        // icon={<CloseIcon />}
                                                        color="red"
                                                        variant="outline"
                                                        onClick={() => removeFeature(index)}
                                                    />


                                                </Flex>
                                            ))}
                                            <Button
                                                mt={2}
                                                colorScheme="green"
                                                onClick={addFeature}
                                            >
                                                {t("Ajouter une caractéristique")}
                                            </Button>
                                        </VStack>

                                    </FormControl>
                                </Flex>
                            </Flex>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                colorScheme='blue'
                                onClick={() => UpdateSubscription(subId)}
                                isLoading={isLoading}
                                isDisabled={isLoading}
                            >
                                {t("Modifier")}
                            </Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>

            }

            <Modal
                size={"full"}
                isOpen={isPreviewOpen}
                onClose={() => {
                    onClosePreview();
                }}
            >
                <ModalOverlay />
                <ModalContent
                    w="auto"
                    maxW="400px"
                    bg="transparent"
                    boxShadow="none"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Box
                        key={subscription?.id}

                        p="6"
                        bg="white"
                        textAlign="center"
                        rounded="2xl"
                        shadow="xl"
                        display="flex"
                        flexDirection="column"
                        justifyContent="space-between"
                        overflowY="auto" // Scroll if content exceeds max height
                    >
                        <Box>
                            <Box >
                                <Heading size="lg" mb="2" color="black" fontWeight="semibold">
                                    {subscription?.name}
                                </Heading>
                                <Text>{subscription?.description}</Text>
                                <Text pt="2" letterSpacing="wide">
                                    <Text as="span" color="orange.400" verticalAlign="top">
                                        €{" "}
                                    </Text>
                                    <Text as="span" fontSize="2xl" fontWeight="semibold" color="orange.400">
                                        {subscription?.price}
                                    </Text>
                                    <Text as="span" fontWeight="medium" color="orange.400">
                                        {" "}
                                        / {subscription?.type === "ANNUEL" ? "Année" : "Mois"}
                                    </Text>
                                </Text>
                            </Box>

                            <Divider mt="4" borderColor="gray.300" />
                            <Flex justify={"center"} pt="5" flexDirection="column" align="center">
                                {subscription?.features.map((feature, index) => (
                                    <Text
                                        textAlign="center"
                                        key={index}
                                        fontSize="md"
                                        fontWeight="semibold"
                                        color="black"
                                        pt="4"
                                    >
                                        {feature}
                                    </Text>
                                ))}
                            </Flex>
                        </Box>
                        <Flex flexDirection="column" mt="8" gap="3">
                            <Input
                                isDisabled
                                type="text"
                                placeholder="Code promo"
                                bg="gray.50"
                                rounded="lg"
                                size="md"
                                border="1px solid"
                                borderColor="gray.300"
                                focusBorderColor="gray.100"
                                // py="4"
                                _placeholder={{ color: "gray" }}
                            />
                            <Button
                                w="full"
                                bg="orange.300"
                                _hover={{ bg: "orange.400" }}
                                transition="all 0.5s ease-in-out"
                                shadow="2xl"
                                py="4"
                                fontWeight="semibold"
                                color="white"
                                rounded="lg"
                            >
                                S'abonner
                            </Button>
                        </Flex>
                    </Box>
                </ModalContent>
            </Modal>
            {/* <Modal
                // initialFocusRef={initialRef}
                // finalFocusRef={finalRef}
                isOpen={isChangeStripeIdOpen}
                onClose={onCloseStripeIdModal}
            >
                <ModalOverlay />

                <ModalContent>
                    <ModalHeader>Mettre à jour les identifiants</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>

                        <FormControl mb={3} >
                            <FormLabel>Identifiant de produit</FormLabel>
                            <Input value={stripeProductId ? stripeProductId : selectedSub?.stripe_product_id} onChange={(e) => setStripeProductId(e.target.value)} placeholder='Product id' />
                        </FormControl>
                        <FormControl >
                            <FormLabel>Identifiant de prix </FormLabel>
                            <Input value={stripePriceId ? stripePriceId : selectedSub?.stripe_price_id} onChange={(e) => setStripePriceId(e.target.value)} placeholder='Price id' />
                        </FormControl>
                    </ModalBody>

                    <ModalFooter>
                        <Button
                            //  isLoading={addingCodeProgress}
                            isDisabled={(!selectedSub?.stripe_product_id && !selectedSub?.stripe_price_id) && !stripeProductId || !stripePriceId} onClick={() => handleStripeIdsChange(subId)} colorScheme='blue' mr={3}>
                            Mettre à jour
                        </Button>
                        <Button onClick={onCloseStripeIdModal}>Annuler</Button>
                    </ModalFooter>
                </ModalContent>


            </Modal> */}
            <AlertDialog
                size={"lg"}
                closeOnOverlayClick={false}
                isOpen={isAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t('Supprimer')}
                        </AlertDialogHeader>

                        <AlertDialogBody>

                            <Text mb={4}>
                                {t("Êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.")}
                            </Text>
                            {type !== "TRIAL" &&

                                <Box
                                    p={3}
                                    bg="orange.50"
                                    borderLeft="4px"
                                    borderColor="orange.400"
                                    borderRadius="md"

                                >
                                    <Flex>
                                        <Icon as={FaExclamationTriangle} color="orange.400" w={5} h={5} mr={2} mt={0.5} />
                                        <Text fontSize={"sm"} color="gray.700">
                                            {t("Attention : Nous allons supprimer cet abonnement de notre base de données, mais il sera seulement archivé sur Stripe pour des raisons comptables. Pour une suppression complète, vous devrez également le supprimer depuis votre compte Stripe.")}
                                        </Text>
                                    </Flex>
                                </Box>
                            }


                        </AlertDialogBody>
                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={() => {
                                onCloseAlert()
                            }}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={() => handleDelete(deleteId)} colorScheme='red' ml={3} >
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>

        </Box>
    )
}

export default GestSubscription